import {Button, CardTitle, Modal, ModalBody} from 'reactstrap';

import {ImpactScoreExplanation} from 'src/components';

type Props = {
  isOpen: boolean,
  toggle: () => void,
  score?: number
}

export const ImpactScoreExplanationModal = ({isOpen, toggle, score}: Props) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    fade={false}
    size="xl"
    modalClassName="height-auto"
  >
    <ModalBody>
      <CardTitle>
        <Button close onClick={toggle}></Button>
      </CardTitle>
      <ImpactScoreExplanation score={score}/>
    </ModalBody>
  </Modal>
);
